import { defineMessages } from 'react-intl';

const messages = {
  ...defineMessages({
    services: {
      id: 'manage-services.services',
      defaultMessage: 'Services',
    },
    practitioners: {
      id: 'manage-services.practitioners',
      defaultMessage: 'Practitioners',
    },
    resources: {
      id: 'manage-services.resources',
      defaultMessage: 'Equipment',
    },
  }),
  addBtn: defineMessages({
    resource: {
      id: 'manage-services.resources.add-resource',
      defaultMessage: 'Add equipment',
    },
    practitioner: {
      id: 'manage-services.practitioners.add-practitioner',
      defaultMessage: 'Add practitioner',
    },
    service: {
      id: 'manage-services.services.add-service',
      defaultMessage: 'Add service',
    },
  }),
  empty: defineMessages({
    resourcesHeader: {
      id: 'manage-services.resources.empty-header',
      defaultMessage: 'No equipment added yet.',
    },
    resourcesText: {
      id: 'manage-services.resources.empty-text',
      defaultMessage: 'Start now by adding a name and availability for all services an equipment can accomodate.',
    },
    practitionersHeader: {
      id: 'manage-services.practitioners.empty-header',
      defaultMessage: 'No practitioners added yet.',
    },
    practitionersText: {
      id: 'manage-services.practitioners.empty-text',
      defaultMessage:
        'Start now by adding a name, contact info and availability for all services a practitioner can offer.',
    },
    servicesHeader: {
      id: 'manage-services.services.empty-header',
      defaultMessage: 'No services added yet',
    },
    servicesText: {
      id: 'manage-services.services.empty-text',
      defaultMessage: 'Start now by adding a name and duration for services.',
    },
  }),
  error: defineMessages({
    problemWithRequest: {
      id: 'manage-services.error.problem-with-request',
      defaultMessage: 'There was a problem with your request.',
    },
  }),
  emptyState: defineMessages({
    plusIcon: {
      id: 'manage-services.empty-state.plus-icon',
      defaultMessage: 'plus icon',
    },
  }),
  newServiceBanner: defineMessages({
    subtitle: {
      id: 'manage-services.new-service-banner.subtitle',
      defaultMessage:
        'By adding a new service you are aware that your service may be priced lower than intended until you reach out to our team through the Contact Us form. By adding a new service, you agree that applicable reservations will be paid out to you at the lowest contracted rate unless otherwise agreed in writing.',
    },
    cta: {
      id: 'manage-services.new-service-banner.cta',
      defaultMessage: 'Contact us',
    },
  }),
};

export default messages;
